import { TokenKit } from './tokenKit.type';
import { NFTKit } from './nftKit.type';

export type Kit = (TokenKit & { nft_kit_id?: number }) | (NFTKit & { symbol?: string; kit_id?: number });

export type MyKit = {
  kit_id: number;
  category: {
    category_id: number;
    name: string;
    description: string;
  };
  service_identifier: string;
  resource_identifier: number;
  project_id: number;
  created_at: string;
  updated_at: string;
  kit_data: Kit & { origin_micro_chain_image: string };
};

export type MyKitCategory = {
  category_id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
};

export enum KindOfKit {
  TokenKit = 'TokenKit',
  NFTKit = 'NFTKit',
  SecurityTokenKit = 'SecurityTokenKit',
  MembershipKit = 'MembershipKit',
  TicketKit = 'TicketKit',
  PointKit = 'PointKit',
}

export type KitFunction = {
  feature_id: number; //기능 id 값
  name: string; //기능명 :: 전송, 발행, 소각, 권한 등 tokenkit에서 지원하는 기능목록이 들어갑니다.
  description: string; //기능 설명
  created_at: string;
  updated_at: string;
};
export type KitFunctionMethodType = {
  description: string; //해당 기능(인자값)에 관한 description입니다.
  feature_id: number;
  function_name: string; //기능 명 입니다. ex) 전송기능 : transfer
  methods: {
    method_id: number;
    input_type: 'single' | 'multiple'; //single : input 단일 항목 입력 , multiple: multicall같은 사용자에게 input값을 1개 이상을 받을 수 있음을 의미합니다.
    method_description: string; //메서드에 대한 설명 입니다.
    method: string; //기능에 속하는 메서드 입니다.
    need_wallet: boolean; //해당 기능을 사용하기 위해서는 지갑이 필요한지 여부입니다.
    owner_only: boolean; //owner만 수행할 수 있는 기능 여부 입니다.
    input: {
      name: string; //메서드를 위해 사용자에게 받아야하는 input명 입니다.
      type: 'address' | 'amount'; //placeholder 구분을 위한 input이 가지는 타입 입니다.
      data_type: 'string' | 'number'; // input이 실제로 받아야하는 데이터 타입
    }[];
  }[];
};
type InputID = string;
export type InputType = {
  type_id: number;
  type_name: string;
  type_description: string;
  type_img: string;
  type_img_alt: string;
  type_img_disabled: string;
  input_id?: InputID;
};
export type Input = {
  valueKey: string;
  label: string;
  description: string;
  type: 'string' | 'file' | 'address' | 'address_optional';
  is_metadata?: boolean;
  metadata_key?: string;
};
export type MethodInput = {
  input_id: InputID;
  required: Input[];
  optional?: Input[];
};
export type KitFunctionMethod = {
  method_id: number;
  method_name: string;
  method_description: string;
  input_type: 'single' | 'multiple' | string;
  need_wallet: boolean;
  owner_only: boolean;
  type?: InputType[];
  input: {
    required: {
      valueKey: string;
      label: string;
      description: string;
      type: 'string' | 'file' | 'address' | string;
    }[];
    optional?: {
      valueKey: string;
      label: string;
      description: string;
      type: 'string' | 'file' | 'address' | string;
      metadata?: {
        valueKey: string;
        label: string;
        description: string;
        type: 'string' | 'file' | 'address' | string;
      }[];
    }[];
  };
  inputs: MethodInput[];
};
export type KitType = {
  kit_type_id: number;
  origin_contract_id: number;
  name: string;
  description: string;
};
export type Contract = {
  contract_id: number;
  micro_chain_id: number;
  name: string;
  project_id: number;
  creator_id: number;
  contract_address: string;
  description: string;
  type: number;
  transaction_hash: string;
  main_status: number;
  sub_status: number;
  erc_type: number;
  is_system: boolean;
  origin_contract_id: number;
  origin_contract_version_id: number;
  origin_version: string;
  implementation_contract_id: number; //여기까지 기존 contract 정보
  contractLibrary: {
    //contract librarby 정보
    contract_version_id: number;
    contract_id: number;
    version: string; //contract의 버전
    version_description: string; //contract의 버전 설명
    status: number;
    is_private: number;
    contract: {
      contract_id: number;
      project_id: number;
      creator_id: number;
      latest_contract_version_id: number;
      title: string; //contract의 title
      description: string; //contract의 description
      type: number; //contract의 type
      erc_type: number | null; //erc의 type 예)erc20 이면 erc_type: 20
      is_official: number;
      contract_standard_id: number;
      deploy_count: number;
      image: string;
    };
    contract_version_code: {
      contract_version_id: number;
      solidity_code: string;
      byte_code: string;
      abi_code: string;
      custom_abi_code: string;
    };
    contract_version_reject_detail: string;
    project: string; //project Id에 해당하는 프로젝트 명
    contract_type_labeling: 'FIXED' | 'PROXY' | 'IMPLEMENTATION' | 'UNKNOWN'; // contract의 type을 라벨링 한 값
  };
};
export type Contract_Constructor = {
  internalType?: string;
  name: string;
  type: string;
  description?: string;
}[];
export type ConnectedWallet = {
  connectWalletType: string;
  connectAddress: string;
  accountId?: string;
  accountName?: string | null;
};

export type ResourceRegistry = {
  resource_registry_id: number;
  category_identifier: number;
  service_identifier: string;
  resource_identifier: number;
  project_id: number;
  serial_hash: string;
  created_at: string;
  updated_at: string;
};
